/**
 * The palette names a chart series may ask for, index-aligned with CHART_COLORS and with the
 * `--chart-1..5` custom properties in index.css. A closed set, because the AI writes the values (a
 * chart Figure's series names one): an unrecognised colour string cannot be told apart from a typo,
 * and a typo would render as a silently off-brand series.
 */
export const CHART_COLOR_TOKENS = ['chart-1', 'chart-2', 'chart-3', 'chart-4', 'chart-5'] as const;

export type ChartColorToken = (typeof CHART_COLOR_TOKENS)[number];

/**
 * Crespect brand palette for data visualisation, in the order the dashboard finalized-hours
 * donut assigns it, as references to the `--chart-*` tokens: SVG `fill` and `stroke` resolve
 * `var()`, so the colour values live only in index.css. A series or slice without a colour of its
 * own takes the entry at its index modulo the length, so the sixth reuses the first.
 */
export const CHART_COLORS = CHART_COLOR_TOKENS.map((token) => `var(--${token})`);
